import React from 'react';
import { Switch, Route } from 'react-router-dom';



import UsersNew from './Users/UsersNew'
import UsersView from './Users/UsersView'
import UsersUpdate from './Users/UsersUpdate'

const view = ({ items }) => {
    return (
        <div className="items-center">
            <nav className="lg:pr-6 flex menu-2 bg-white shadow-md font-semibold text-xs rounded-sm text-vivid-900">
                <ul className="wtf-menu flex w-full">
                    {items}
                </ul>
            </nav>
            <div className="route">
                <Switch>
                    <Route exact path="/settings" component={null} />
                    <Route path="/settings/users/add" component={UsersNew} />
                    <Route path="/settings/users/edit" component={UsersView} />
                    <Route path="/settings/users/:id" component={UsersUpdate} />
                </Switch>
            </div>
        </div>
    );
};

export default view;